export const shuffle = (arr) => {
  arr.sort(() => 0.5 - Math.random());
  return arr;
};
